<script setup>
const props = defineProps({
  content: {
    type: Object,
    default: () => ({
      name: '',
      pref: '',
      center: {},
      href: ''
    })
  }
})
const fcst10dData = ref(null)
const runtimeConfig = useRuntimeConfig()
const route = useRoute()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
if (import.meta.client) {
  const { data: response } = await useFetch('/api/wxdata/fcst10d', { query: { lat: props.content.center.lat, lon: props.content.center.lon } })
  watch(() => response.value, () => {
    fcst10dData.value = response.value
  }, { immediate: true })
}
</script>

<template>
  <ClientOnly>
    <NuxtLink
      :to="`${isWebViewFlag ? `${runtimeConfig.app.baseURL}${content.href.replace(/^\//, '')}` : content.href===route.path ? `${runtimeConfig.app.baseURL}${content.href.replace(/^\//, '')}` : content.href}`"
      class="golfCalendar"
      :external="isWebViewFlag || content.href===route.path"
    >
      <div class="header">
        <h3 class="heading">
          {{ content.name.replace(/[（/]旧.*$/, '') }}
        </h3>
        <p class="pref">
          {{ content.pref }}
        </p>
      </div>
      <div class="calendar">
        <div
          v-for="(item, index) in fcst10dData"
          :key="index"
          class="column"
        >
          <div
            class="day"
            :data-dow="item.dowEn"
          >
            <p class="date">
              {{ item.day }}
            </p>
            <p class="dow">
              ({{ item.dowJp }})
            </p>
          </div>
          <figure class="weather">
            <img
              :src="`https://gvs.weathernews.jp/onebox/img/wxicon/${item.weather}.webp`"
              alt=""
              loading="lazy"
            >
          </figure>
          <div class="temp">
            <p class="maxTemp">
              {{ item.high === null ? '-' : item.high }}<span class="unit">℃</span>
            </p>
            <p class="minTemp">
              {{ item.low === null ? '-' :item.low }}<span class="unit">℃</span>
            </p>
          </div>
          <p class="prec">
            {{ item.rain === null ? '-' : item.rain }}<span class="unit">%</span>
          </p>
          <figure class="status">
            <img
              :src="`https://gvs.weathernews.jp/golf/image/golf_status/icon_status_${item.status}.svg`"
              alt=""
              loading="lazy"
            >
          </figure>
        </div>
      </div>
      <p class="link">
        <span>このゴルフ場を詳しく見る</span>
        <img
          src="https://gvs.weathernews.jp/golf/image/common/icon_arrow_blue_circle.svg"
          width="20"
          height="20"
          alt=""
          loading="lazy"
        >
      </p>
    </Nuxtlink>
  </ClientOnly>
</template>

<style lang="scss" scoped>
.golfCalendar {
  display: flex;
  flex-direction: column;
  gap: 15px;
  .header {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .heading {
    padding-left: 15px;
    border-left: solid 5px #c6ccda;
    color: #000;
    font-size: 18px;
    font-weight: 600;
    line-height: 25px;
    letter-spacing: .25px;
    @media screen and (min-width: 830px) {
      font-size: 22px;
    }
  }
  .pref {
    padding: 5px 10px 4px;
    background-color: #3569C0;
    color: #FFF;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 1em;
    white-space: nowrap;
  }
  .calendar {
    display: flex;
    justify-content: space-between;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 100vmax;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 100vmax;
      background: #438fec;
    }
    .column {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 5px;
      padding: 5px 2px;
      width: calc(100% / 11);
      min-width: 48px;
      border-radius: 4px;
      &:first-child {
        background-color: #F0F3F9;
        .day {
          background-color: #fff;
        }
      }
    }
    .day {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2px;
      width: calc(100% - 2px);
      min-width: 44px;
      padding-top: 3px;
      padding-bottom: 3px;
      border-radius: 4px;
      background-color: #F0F3F9;
      &[data-dow="sat"] {
        background-color: #D8D8EE;
      }
      &[data-dow="hol"] {
        background-color: #EDCCDD;
      }
    }
    .dow {
      color: #000;
      text-align: center;
      font-size: 15px;
      font-weight: 600;
      line-height: 1em;
    }
    .date {
      color: #000;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      line-height: 1em;
    }
    .weather {
      aspect-ratio: 152 / 112;
      min-width: 44px;
      img {
        width: 100%;
      }
    }
    .temp {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 3px;
      padding-block: 2px;
      p {
        font-size: 18px;
        font-weight: 600;
        line-height: 1em;
      }
    }
    .maxTemp {
      color: #F64D00;
    }
    .minTemp {
      color: #0075F3;
    }
    .prec {
      color: #000;
      font-size: 15px;
      font-weight: 600;
      line-height: 1em;
      padding-left: 10px;
      background-image: url('https://gvs.weathernews.jp/golf/image/common/icon_prec.svg');
      background-position: left center;
      background-repeat: no-repeat;
      background-size: 8px;
    }
    .unit {
      font-size: 13px;
      font-weight: 400;
    }
    .status {
      aspect-ratio: 1 / 1;
      width: 100%;
      max-width: 40px;
      min-width: 30px;
      img {
        width: 100%;
      }
    }
  }
  .link {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-left: auto;
    span {
      color: #3569C0;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      text-decoration: underline;
      white-space: nowrap;
      @media screen and (min-width: 830px) {
        font-size: 18px;
      }
    }
    img {
      width: 20px;
    }
  }
  @media (any-hover: hover) {
    transition: opacity .2s ease-in-out;
    &:hover {
      opacity: .6;
    }
  }
}
.main {
  .golfCalendar {
    @media screen and (min-width: 830px) {
      .calendar {
        overflow-x: visible;
      }
    }
  }
}
</style>
